














































import { defineComponent } from '@vue/composition-api';
import { useVModel } from '@vueuse/core';

export default defineComponent({
  props: {
    value: { type: Boolean },

    title: { type: String },
    description: { type: String }
  },

  setup(props) {
    const isActive = useVModel(props);

    return {
      isActive
    };
  }
});
